import { memo } from "react";
import { TableCell } from "@mui/material";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import { useSortable } from "@dnd-kit/sortable";
import styles from "./CustomTable.module.css";

/**
 * Header cell with a grab handle. Layout transforms are disabled so sticky
 * table columns stay intact; visual feedback uses opacity + drop indicator.
 */
function SortableHeaderCell({
  id,
  label = "",
  className = "",
  style,
  sortDirection,
  children,
  disabled = false,
}) {
  const { attributes, listeners, setNodeRef, isDragging, isOver } = useSortable({
    id,
    disabled,
    animateLayoutChanges: () => false,
  });

  const cellClass = [
    className,
    styles["header-cell--reorderable"],
    isDragging ? styles["header-cell--dragging"] : "",
    isOver && !isDragging ? styles["header-cell--drop-target"] : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <TableCell
      ref={setNodeRef}
      className={cellClass}
      sortDirection={sortDirection}
      style={style}
      data-column-key={id}
    >
      <div className={styles["header-cell-reorder-inner"]}>
        <div className={styles["header-cell-reorder-body"]}>{children}</div>
        <button
          type="button"
          className={styles["column-drag-handle"]}
          aria-label={`Drag to reorder column${label ? `: ${label}` : ""}`}
          title="Drag to reorder"
          {...attributes}
          {...listeners}
        >
          <DragIndicatorIcon fontSize="inherit" />
        </button>
      </div>
    </TableCell>
  );
}

export default memo(SortableHeaderCell);
